import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{attrs:{"id":"inspire"}},[_c(VMain,[_c(VImg,{attrs:{"src":require(`@/assets/pp-transparent.png`),"height":"150","alt":"pp-logo","contain":"","id":"pp-logo"}}),_c(VContainer,{staticClass:"fill-height",style:({
        backgroundImage: 'url(' + require('@/assets/bg1.webp') + ')'
      }),attrs:{"fluid":"","id":"maincontainner"}},[_c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VCol,{attrs:{"cols":"12","sm":"8","md":"4"}},[_c(VCard,{staticClass:"elevation-12"},[_c('router-view')],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }